// @ts-nocheck


import { classesRuntime, statesRuntime } from "../../stylable-esm-runtime.js";



var _namespace_ = "CmsFieldForm3637905500";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st: import("@stylable/runtime").STFunction = _style_;

export var namespace = _namespace_;
export var classes = {"root":"CmsFieldForm3637905500__root","fullBleedDivider":"CmsFieldForm3637905500__fullBleedDivider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-space-300":"--wds-space-300","wds-custom-modal-content-padding-horizontal":"--wds-custom-modal-content-padding-horizontal"}; 




